import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { feedbacksService } from '@services/feedbacks';
import { handleApiError } from '@helpers/api';
import { RoutePath } from '@constants/routes';

const SurveyResponsePhotoPage = () => {
    const { photoId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        feedbacksService
            .getPhotoLink(photoId)
            .then(({ url }) => window.location.replace(url))
            .catch(error => {
                handleApiError(error);
                navigate(RoutePath.SurveysResponses, { replace: true });
            });
    }, [photoId]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '48px' }}>
            <CircularProgress />
        </Box>
    );
};

export default SurveyResponsePhotoPage;
